// extracted by mini-css-extract-plugin
export default {"component":"WidgetDuration_component__OCOGo","titleContainer":"WidgetDuration_titleContainer__lHLjh","list":"WidgetDuration_list__HqnU4"};